import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import spinner from './spinner.svg';

import style from './style.scss';

export class LoadingSpinner extends React.PureComponent {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  static propTypes = {
    isLoading: PropTypes.bool
  };

  static defaultProps = {
    isLoading: false
  };

  componentDidMount() {
    this.loadingRoot.appendChild(this.el);
  }

  componentWillUnmount() {
    this.loadingRoot.removeChild(this.el);
  }

  loadingRoot = document.getElementById('loading-root');

  render() {
    const { isLoading } = this.props;

    return (
      isLoading &&
      ReactDOM.createPortal(
        <div>
          <div className={style.modalOverlay} />
          <div className={style.modalContent}>
            <img
              src={spinner}
              title="Loading"
              alt="Loading"
              className={style.spinner}
            />
          </div>
        </div>,
        this.el
      )
    );
  }
}

const mapStateToProps = state => {
  const isLoading = Object.values(state).some(stateEntry => {
    const { isLoading } = stateEntry;

    return isLoading;
  });

  return {
    isLoading
  };
};

export default connect(mapStateToProps)(LoadingSpinner);



// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/index.js